import {
    GET_CATEGORIES_BENEFITS_MARKETPLACE,
    GET_CATEGORY_TYPE_MARKETPLACE,
    GET_SUBCATEGORIES_MARKETPLACE,
    GET_STATE_LOADING_MARKETPLACE,
    GET_CATEGORIES_ID_MARKETPLACE,
    GET_CATEGORIES_MARKETPLACE,
    GET_MODO_MARKETPLACE,
} from "@/views/categories_marketplace/store/types/types.js";

const getters = {
    [GET_CATEGORIES_BENEFITS_MARKETPLACE]: state => state.categories_marketplace_benefits,
    [GET_CATEGORY_TYPE_MARKETPLACE]: state => state.categories_type_marketplace,
    [GET_SUBCATEGORIES_MARKETPLACE]: state => state.subcategories_marketplace,
    [GET_STATE_LOADING_MARKETPLACE]: state => state.loading_marketplace,
    [GET_CATEGORIES_MARKETPLACE]: state => state.categories_marketplace,
    [GET_CATEGORIES_ID_MARKETPLACE]: state => state.categoryM,
    [GET_MODO_MARKETPLACE]: state => state.modos_marketplace,

};

export default getters;